import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from "react-router-dom";
import './index.css';
import App from './App';
import { Configuration, PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { ERRORS } from './constants/errorMessages';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const redirectUri = window.location.origin as string;
const authorityUrl = process.env.REACT_APP_AUTHORITY_URL as string;
const clientId = process.env.REACT_APP_CLIENTID as string;

// MSAL configuration
const configuration: Configuration = {
  auth: {
    clientId: clientId,
    authority: authorityUrl,
    redirectUri: redirectUri,
    postLogoutRedirectUri: redirectUri,
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false
  }
};

const publicClientApplication = new PublicClientApplication(configuration);

async function renderApp() {
  await publicClientApplication.initialize();

  const response = await publicClientApplication.handleRedirectPromise();

  if (response?.account) {
    publicClientApplication.setActiveAccount(response.account);
  } else {
    const accounts = publicClientApplication.getAllAccounts();
    if (accounts.length > 0) {
      publicClientApplication.setActiveAccount(accounts[0]);
    }
  }

  if (response?.state) {
    try {
      //decode base64 redirect relative path
      const { redirectPath } = JSON.parse(atob(response.state));
      
      if (redirectPath && typeof redirectPath === "string") {
        //prevent Open Redirect vulnerability
        const url = new URL(redirectPath, window.location.origin);
        if (url.origin === window.location.origin) {
          window.history.replaceState({}, "", url.pathname + url.search + url.hash);
        }

        // Use History API to avoid a second full load
        window.history.replaceState({}, "", redirectPath);
      }
    } catch (error) {
      console.warn(ERRORS.failToParseLoginState, error);
    }
  }

  root.render(
    <React.StrictMode>
      <MsalProvider instance={publicClientApplication}>
        <Router>
          <App />
        </Router>
      </MsalProvider>
    </React.StrictMode>
  );
}

renderApp();
